module.exports = __webpack_public_path__ + "img/Back Door Window.db84bb1c.png";